import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 新增 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 查看 ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 状态切换 ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("预告");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("直播中");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("回放");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("下架");

const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 预约记录 ");

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ArrowDown } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getLiveList, updateLiveStatus } from '@/request';
import { getVexTableProps, dateTimeFormat } from '@/config';
export default {
  name: 'LiveList',

  setup(__props) {
    const router = useRouter();
    const table = ref();
    const form = ref({
      title: '',
      status: '',
      timeRange: []
    });
    const statusMap = {
      1: '预告',
      2: '直播中',
      3: '回放',
      4: '下架'
    };

    function statusText(status) {
      return statusMap[status] || '-';
    }

    function statusTagType(status) {
      if (status === 1) return 'warning';
      if (status === 2) return 'danger';
      if (status === 3) return 'info';
      return '';
    }

    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        field: 'liveId',
        title: 'ID',
        width: '80px'
      }, {
        title: '封面',
        slots: {
          default: 'cover'
        },
        width: '100px'
      }, {
        field: 'title',
        title: '标题',
        minWidth: '200px',
        showOverflow: true
      }, {
        field: 'anchorName',
        title: '主播',
        width: '120px',
        showOverflow: true
      }, {
        title: '状态',
        slots: {
          default: 'status'
        },
        width: '100px'
      }, {
        field: 'startTime',
        title: '开播时间',
        width: '170px'
      }, {
        field: 'viewerCount',
        title: '观看数',
        width: '90px'
      }, {
        field: 'voteCount',
        title: '点赞',
        width: '80px'
      }, {
        field: 'collectCount',
        title: '收藏',
        width: '80px'
      }, {
        field: 'subscribeCount',
        title: '预约人数',
        width: '100px'
      }, {
        field: 'sort',
        title: '排序',
        width: '80px'
      }, {
        field: 'createBy',
        title: '创建人',
        width: '120px',
        showOverflow: true
      }, {
        field: 'updateAt',
        title: '更新时间',
        width: '170px'
      }, {
        title: '操作',
        fixed: 'right',
        width: '360px',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            const params = {
              page: page.currentPage,
              pageSize: page.pageSize,
              title: form.value.title || undefined,
              status: form.value.status === '' ? undefined : form.value.status
            };

            if (form.value.timeRange && form.value.timeRange.length === 2) {
              params.startTimeFrom = form.value.timeRange[0];
              params.startTimeTo = form.value.timeRange[1];
            }

            getLiveList(params).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      }
    });

    function reset() {
      form.value = {
        title: '',
        status: '',
        timeRange: []
      };
      table.value.commitProxy('reload');
    }

    function changeStatus(row, status) {
      ElMessageBox.confirm(`确认将「${row.title}」切换为「${statusText(status)}」？`, '状态切换').then(() => {
        updateLiveStatus({}, {
          params: {
            liveId: row.liveId,
            status,
            __repeat: true,
            __warn: true
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success(data.msg || '操作成功');
            table.value.commitProxy('query');
          }
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "直播标题"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.title = $event),
                clearable: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.status,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.status = $event),
                clearable: "",
                placeholder: "全部"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "预告",
                  value: 1
                }), _createVNode(_component_el_option, {
                  label: "直播中",
                  value: 2
                }), _createVNode(_component_el_option, {
                  label: "回放",
                  value: 3
                }), _createVNode(_component_el_option, {
                  label: "下架",
                  value: 4
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "开播时间"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.timeRange,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.timeRange = $event),
                type: "datetimerange",
                "range-separator": "至",
                "start-placeholder": "开始",
                "end-placeholder": "结束",
                "value-format": _unref(dateTimeFormat)
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: _cache[4] || (_cache[4] = $event => _unref(router).push({
            name: 'SaveLive'
          }))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        cover: _withCtx(({
          row
        }) => [_createVNode(_component_el_image, {
          style: {
            "width": "70px",
            "height": "70px"
          },
          src: row.coverUrl,
          "preview-src-list": [row.coverUrl],
          fit: "cover"
        }, null, 8, ["src", "preview-src-list"])]),
        status: _withCtx(({
          row
        }) => [_createVNode(_component_el_tag, {
          type: statusTagType(row.status)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(statusText(row.status)), 1)]),
          _: 2
        }, 1032, ["type"])]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "success",
          onClick: $event => _unref(router).push({
            name: 'SaveLive',
            query: {
              id: row.liveId,
              isSee: true
            }
          })
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Edit",
          onClick: $event => _unref(router).push({
            name: 'SaveLive',
            query: {
              id: row.liveId
            }
          })
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_dropdown, {
          style: {
            "margin-left": "8px"
          },
          onCommand: cmd => changeStatus(row, cmd)
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
              command: 1,
              disabled: row.status === 1
            }, {
              default: _withCtx(() => [_hoisted_7]),
              _: 2
            }, 1032, ["disabled"]), _createVNode(_component_el_dropdown_item, {
              command: 2,
              disabled: row.status === 2
            }, {
              default: _withCtx(() => [_hoisted_8]),
              _: 2
            }, 1032, ["disabled"]), _createVNode(_component_el_dropdown_item, {
              command: 3,
              disabled: row.status === 3
            }, {
              default: _withCtx(() => [_hoisted_9]),
              _: 2
            }, 1032, ["disabled"]), _createVNode(_component_el_dropdown_item, {
              command: 4,
              disabled: row.status === 4
            }, {
              default: _withCtx(() => [_hoisted_10]),
              _: 2
            }, 1032, ["disabled"])]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createVNode(_component_el_button, null, {
            default: _withCtx(() => [_hoisted_6, _createVNode(_component_el_icon, {
              class: "el-icon--right"
            }, {
              default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 2
        }, 1032, ["onCommand"]), _createVNode(_component_el_button, {
          style: {
            "margin-left": "8px"
          },
          onClick: $event => _unref(router).push({
            name: 'LiveSubscribeList',
            query: {
              liveId: row.liveId,
              title: row.title
            }
          })
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16)]);
    };
  }

};